import React from "react"
import { TextField, MenuItem } from "@mui/material"

import { FallbackLockingSystemRowConfiguration } from "./LockingSystemRowConfigurations"

import useOuterLengthsBySystemConfiguration from "@secureo/common/hooks/cylinderConfigurations/useOuterLengthsBySystemConfiguration"

import { OuterLengthsBySystem } from "@secureo/common/typings/Product"
import { GridTemplateRowName } from "../LockingSystemMatrix"
import LockingSystemItemWrapper from "../LockingSystemItemWrapper"
import StyledLockingSystemCell from "../StyledLockingSystemCell"

const SystemAndOuterLengthConfiguration = ({
	isLoading,
	uuid,
	gridRowName,
	outerLengthsBySystem,
	selectedSystem,
	selectedOuterLength,
	setSelectedOuterLength,
}: Props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const onSystemChange = (_: string) => {
		//
	}

	const onOuterLengthChange = (selectedOuterLength: number) => {
		setSelectedOuterLength(uuid, selectedOuterLength)
	}

	const { outerLengthInputProps, availableOuterLengths } = useOuterLengthsBySystemConfiguration(
		outerLengthsBySystem,
		selectedSystem,
		selectedOuterLength,
		onSystemChange,
		onOuterLengthChange,
	)

	return (
		<>
			<StyledLockingSystemCell gridRowName={gridRowName} gridColumnName="outerLength">
				<LockingSystemItemWrapper>
					<TextField
						label="A"
						{...outerLengthInputProps}
						margin="normal"
						variant="filled"
						select
						fullWidth
						disabled={isLoading || !setSelectedOuterLength}
						style={{ marginTop: 0 }}
					>
						{availableOuterLengths.map((outerLength) => (
							<MenuItem key={outerLength} value={outerLength}>
								{outerLength} mm
							</MenuItem>
						))}
					</TextField>
				</LockingSystemItemWrapper>
			</StyledLockingSystemCell>

			<FallbackLockingSystemRowConfiguration
				gridRowName={gridRowName}
				gridColumnName="innerLength"
			/>
		</>
	)
}

interface Props {
	isLoading: boolean
	uuid: string
	gridRowName: GridTemplateRowName
	outerLengthsBySystem: OuterLengthsBySystem
	selectedSystem: string
	selectedOuterLength: number
	setSelectedOuterLength?: (uuid: string, selectedOuterLength: number) => void
}

export default SystemAndOuterLengthConfiguration
